// Copyright (c) Ping. All rights reserved.
//
// Light/dark icon colors for call CHROME (topbar, menus, panels, control bar,
// minimized card). Backgrounds / text / borders are themed with `dark:` classes
// per the styling rules; lucide icons take a JS `color` prop, so they read the
// resolved scheme here. Icons that sit on TOP of video (name tags, presenter
// chips, zoom bar) stay light-on-dark always for legibility and do NOT use this.

import { useColorScheme } from '@ping/ui/src/foundations/colorScheme';

export interface CallIconColors {
  /** Primary chrome icon (e.g. control-bar glyphs, menu rows). */
  readonly primary: string;
  /** Muted chrome icon (e.g. topbar minimize/maximize, captions). */
  readonly muted: string;
}

export function useCallIconColors(): CallIconColors {
  const scheme = useColorScheme();
  return scheme === 'dark'
    ? { primary: '#E8EAED', muted: '#8C929E' }
    : { primary: '#2E3138', muted: '#5B6472' };
}
